"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _uiKit = require("@devsta/ui-kit"),
    _getValueFromGenericInput = require("@devsta/get-value-from-generic-input"),
    _AssetPreview = _interopRequireDefault(require("../../AssetPreview")),
    _Loading = _interopRequireDefault(require("./Loading")),
    _FileInfo = _interopRequireDefault(require("./FileInfo")),
    _queries = require("../queries"),
    _mutations = require("../mutations"),
    _utils = require("../utils"),
    _makeRequest = _interopRequireDefault(require("../../../common/utils/makeRequest")),
    _DownloadAssetMenu = require("../../DownloadAssetMenu");

require("../styles/_manage-asset-modal.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var ManageAssetModal = function (_Component) {
  function ManageAssetModal(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, ManageAssetModal), _this = _super.call(this, props), _this.updateInputField = (0, _lodash["default"])(function (fieldName) {
      return function (result) {
        _this.setState((0, _defineProperty2["default"])({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
      };
    }), _this.handleSave = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var _this$props, assetId, apiClient, onSave, _this$state, title, description, altText, tags, requestParams, _yield$makeRequest, data, error;

      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              return _this$props = _this.props, assetId = _this$props.assetId, apiClient = _this$props.apiClient, onSave = _this$props.onSave, _this$state = _this.state, title = _this$state.title, description = _this$state.description, altText = _this$state.altText, tags = _this$state.tags, requestParams = {
                mutation: _mutations.updateAsset,
                variables: {
                  assetId: assetId,
                  input: {
                    title: title,
                    description: description,
                    altText: altText,
                    tags: tags
                  }
                },
                context: {
                  module: "assets"
                }
              }, _context.next = 5, (0, _makeRequest["default"])({
                request: apiClient.mutate,
                requestParams: requestParams,
                showErrorNotification: !0
              });

            case 5:
              if (_yield$makeRequest = _context.sent, data = _yield$makeRequest.data, error = _yield$makeRequest.error, data && !error && onSave) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              onSave(data);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.updateTags = function (tags) {
      _this.setState({
        tags: tags
      });
    }, _this.getDate = function (updatedAt) {
      return "".concat((0, _moment["default"])(updatedAt, ["x", "YYYY-MM-DDTHH:mm:ss.sssZ"]).format("Do MMM YYYY [at] HH:mm[]A"));
    }, _this.fetchAsset = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2() {
      var _this$props2, assetId, apiClient, requestParams, _yield$makeRequest2, data, error, asset, _asset$title, title, _asset$description, description, _asset$tags, tags, _asset$altText, altText;

      return _regenerator["default"].wrap(function (_context2) {
        for (;;) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _this$props2 = _this.props, assetId = _this$props2.assetId, apiClient = _this$props2.apiClient, requestParams = {
                query: _queries.getAsset,
                variables: {
                  assetId: assetId
                },
                context: {
                  module: "assets"
                },
                fetchPolicy: "network-only"
              }, _context2.next = 4, (0, _makeRequest["default"])({
                request: apiClient.query,
                requestParams: requestParams,
                showErrorNotification: !0
              });

            case 4:
              if (_yield$makeRequest2 = _context2.sent, data = _yield$makeRequest2.data, error = _yield$makeRequest2.error, data && data.getAsset && !error) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: error,
                isLoading: !1
              }));

            case 9:
              asset = data.getAsset, _asset$title = asset.title, title = void 0 === _asset$title ? "" : _asset$title, _asset$description = asset.description, description = void 0 === _asset$description ? "" : _asset$description, _asset$tags = asset.tags, tags = void 0 === _asset$tags ? "" : _asset$tags, _asset$altText = asset.altText, altText = void 0 === _asset$altText ? "" : _asset$altText, _this.setState({
                isLoading: !1,
                asset: asset,
                title: title,
                description: description,
                altText: altText,
                tags: tags
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), _this.resetState = function () {
      _this.setState({
        isLoading: !0,
        asset: void 0,
        title: "",
        description: "",
        tags: "",
        altText: ""
      });
    }, _this.componentDidUpdate = function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(prevProps) {
        var prevIsVisible, isVisible, isUpdatingVisibilityToTrue;
        return _regenerator["default"].wrap(function (_context3) {
          for (;;) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (prevIsVisible = prevProps.isVisible, isVisible = _this.props.isVisible, isUpdatingVisibilityToTrue = !prevIsVisible && isVisible, isUpdatingVisibilityToTrue) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                return _this.resetState(), _context3.next = 8, _this.fetchAsset();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function () {
        return _ref3.apply(this, arguments);
      };
    }(), _this.componentDidMount = function () {
      var isVisible = _this.props.isVisible;
      isVisible && _this.fetchAsset();
    }, _this.getModalContent = function () {
      var _this$state2 = _this.state,
          asset = _this$state2.asset,
          error = _this$state2.error,
          isLoading = _this$state2.isLoading,
          _this$props3 = _this.props,
          isVisible = _this$props3.isVisible,
          readOnly = _this$props3.readOnly,
          disableInput = !!error || readOnly;
      if (isLoading) return _react["default"].createElement(_Loading["default"], null);

      var _ref4 = asset || {},
          filename = _ref4.filename,
          altText = _ref4.altText,
          title = _ref4.title,
          description = _ref4.description,
          updatedAt = _ref4.updatedAt,
          updatedByUser = _ref4.updatedByUser,
          tags = _ref4.tags,
          metaData = _ref4.metaData;

      return _react["default"].createElement("div", {
        className: "manage-asset-modal"
      }, _react["default"].createElement("div", {
        className: "manage-asset-modal__left-content"
      }, _react["default"].createElement("div", {
        className: "manage-asset-modal__asset-container"
      }, asset && isVisible ? _react["default"].createElement(_AssetPreview["default"], {
        asset: asset,
        canPlayAudio: !0,
        canPlayVideo: !0,
        height: "100%",
        borderRadius: 6,
        hideFileTypeIcon: !0
      }) : null), _react["default"].createElement("div", {
        className: "manage-asset-modal__updated-by-block"
      }, updatedByUser && _react["default"].createElement("span", null, "Updated by ".concat(updatedByUser.firstName, " ").concat(updatedByUser.lastName), updatedAt && " - ".concat(_this.getDate(updatedAt))), _react["default"].createElement(_DownloadAssetMenu.DownloadAssetMenu, {
        asset: asset
      }, _react["default"].createElement(_uiKit.Button, {
        prefix: "download",
        className: "manage-asset-modal__updated-by-block__download",
        small: !0,
        type: "SECONDARY"
      }, "DOWNLOAD")))), _react["default"].createElement("div", {
        className: "manage-asset-modal__right-content"
      }, _react["default"].createElement(_FileInfo["default"], {
        filename: filename ? (0, _utils.transformFilename)(filename) : "N/A",
        metaData: metaData || {}
      }), _react["default"].createElement("div", {
        className: "manage-asset-modal__input-container"
      }, _react["default"].createElement(_uiKit.Input, {
        label: "TITLE*",
        validate: Boolean,
        defaultValue: title,
        placeholder: "Enter title",
        onChange: _this.updateInputField("title"),
        disabled: disableInput
      }), _react["default"].createElement(_uiKit.Input, {
        label: "DESCRIPTION",
        defaultValue: description,
        placeholder: "Enter description",
        onChange: _this.updateInputField("description"),
        disabled: disableInput
      }), _react["default"].createElement(_uiKit.Input, {
        label: "ALT TEXT",
        defaultValue: altText,
        placeholder: "Alt text",
        onChange: _this.updateInputField("altText"),
        disabled: disableInput
      }), _react["default"].createElement(_uiKit.TagInput, {
        id: "tag-input",
        label: "Tags",
        defaultValue: tags,
        onChange: _this.updateTags,
        disabled: disableInput
      }))));
    }, _this.state = {
      isLoading: !0
    }, _this;
  }

  (0, _inherits2["default"])(ManageAssetModal, _Component);

  var _super = _createSuper(ManageAssetModal);

  return (0, _createClass2["default"])(ManageAssetModal, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          modalSubtitle = _this$props4.modalSubtitle,
          isVisible = _this$props4.isVisible,
          onClose = _this$props4.onClose,
          readOnly = _this$props4.readOnly,
          _this$state3 = this.state,
          isLoading = _this$state3.isLoading,
          error = _this$state3.error;
      return _react["default"].createElement(_uiKit.FormModal, {
        visible: isVisible,
        onClose: onClose,
        onSave: this.handleSave,
        className: (0, _classnames["default"])("form-modal__container"),
        title: "Edit Asset Details",
        subtitle: modalSubtitle,
        saveDisabled: !!error || isLoading || readOnly
      }, this.getModalContent());
    }
  }]), ManageAssetModal;
}(_react.Component),
    _default = ManageAssetModal;

exports["default"] = _default;